import { render, staticRenderFns } from "./exchange-rate-card-form.vue?vue&type=template&id=5a8ff909&scoped=true&lang=pug"
import script from "./exchange-rate-card-form.vue?vue&type=script&lang=js"
export * from "./exchange-rate-card-form.vue?vue&type=script&lang=js"
import style0 from "./exchange-rate-card-form.vue?vue&type=style&index=0&id=5a8ff909&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ff909",
  null
  
)

export default component.exports